import React, { useContext, useState, useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";
import { AppContext } from "../../components/States/AppContext";

// components
import TopBar from "../MonitorComponents/TopBar";
import MessageBox from "../MonitorComponents/MessageBox";
import PatientDemo from "../MonitorComponents/PatientDemo";

// styles
import {
  ContentBox,
  GlobalStyles,
  Screen,
  ScreenTest,
} from "../../GlobalStyles.styles";

// icons
import { AiFillLock } from "react-icons/ai";


const Layout = () => {
  const { state, setState } = useContext(AppContext);

  const [clickPosition, setClickPosition] = useState(null);
  const screenRef = useRef(null);

  const handleTouchClick = (event) => {
    const screenRect = screenRef.current.getBoundingClientRect();
    const offsetX = event.clientX - screenRect.left;
    const offsetY = event.clientY - screenRect.top;
    setClickPosition({ x: offsetX, y: offsetY });
  };

  useEffect(() => {
    if (clickPosition) {
      const timeoutId = setTimeout(() => {
        setClickPosition(null);
        // setState((prevState) => ({
        //   // ...prevState,

        // }));
      }, 500);

      return () => clearTimeout(timeoutId);
    }
  }, [clickPosition]);

  return (
    <>
     
      <ScreenTest onClick={handleTouchClick} ref={screenRef}>
        {clickPosition && state.isLocked && !state.isButtonPressed  ? (
          <AiFillLock
            style={{
              position: "absolute",
              width: "15px",
              height: "15px",
              color: "red",
              top: clickPosition.y + "px",
              left: clickPosition.x + "px",
              zIndex: "1000",
            }}
          />
        ) : (
          clickPosition && (
            <div
              style={{
                position: "absolute",
                width: "7px",
                height: "7px",
                borderRadius: "50%",
                backgroundColor: "#caceca",
                top: clickPosition.y + "px",
                left: clickPosition.x + "px",
                zIndex: "1000",
              }}
            />
          )
        )}
        <TopBar />
        <MessageBox />
        <PatientDemo />
        <ContentBox>
          <Outlet />
        </ContentBox>
      </ScreenTest>

   
    </>
  );
};

export default Layout;
